(function () {
    'use strict';

    angular.module('app.controllers.overviewHeatingCircuit', [])
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider.state('overviewheatingcircuit', {
                abstract: true,
                parent: 'device',
                template: '<ui-view/>',
                url: '/OverviewHeatingCircuit'
            });
        }])
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider.state('overviewheatingcircuit.default', {
                parent: 'overviewheatingcircuit',
                url: '/:menuEntryId',
                templateUrl: 'views/CustomActions/overviewheatingcircuit.html',
                defaultParams: {menuEntryId: '00000000-0000-0000-0000-000000000000'},
                controller: 'OverviewHeatingCircuitCtrl',
                breadcrumb: {
                    name: function () {
                        return 'NAV_OverviewHeatingCircuit';
                    }
                },
                resolve: {
                    loadMyCtrl: ['$ocLazyLoad', function($ocLazyLoad) {
                        return $ocLazyLoad.load('scripts/bower_components/fabric.min.js');
                    }]
                }
            });
        }])



        .controller('OverviewHeatingCircuitCtrl', OverviewHeatingCircuitCtrl);

    /* @ngInject */
    function OverviewHeatingCircuitCtrl(
        $scope,
        $translate,
        __MenuEntry,
        viewMenuBarService,

        $timeout,
        API,
        $q,
        xCenterConfig,

        $rootScope,
        actualDevice,
        $interval,
        ENUM,

        $log,
        $state,
        overviewCircuitService,

        f_User,
        versionMappingService,
        frontEndSettingsService
        ) {

        overviewCircuitService.activateLoading();
        overviewCircuitService.initVersionedDatapoints();

        if (!actualDevice.ConfigVersion) {
            $log.error('actualDevice doesn\'t contain ConfigVersion, reloading page');
            $timeout(function () {
                $state.reload();
            }, 500);
            return;
        }

        /* jshint validthis: true */
        var vm = this;
        var ranOnce = false;
        var hpBufferSystem;
        $scope.vm = vm;
        vm.debug = false && f_User.is('AdminAccess');

        vm.DeviceConfigVersion = actualDevice.ConfigVersion;
        if (vm.DeviceConfigVersion === undefined || vm.DeviceConfigVersion === null || vm.DeviceConfigVersion < 0) {
            vm.DeviceConfigVersion = 1;
        }

        var deviceTypes;
        var stopLoadTimers = {
            configs: false,
            dpValues: false,
            deviceTypes: false,
            heatpumpStateLastChanged: false
        };

        const HeatingTwe = Object.freeze({
            Heating: Symbol("Heating"),
            Twe: Symbol("Twe"),
            Both: Symbol("Both")
        });
        function getHeatingTwe(enumId) {
            switch (enumId) {
                case 0:
                    return HeatingTwe.Heating;
                case 1:
                    return HeatingTwe.Twe;
                case 2:
                    return HeatingTwe.Both;
                default:
                    $log.error(`HeatingTwe enum of the value ${enumId} does not exist!`);
            }
        }

        var DpType = {};
        DpType.Float = overviewCircuitService.createDpType('Float');
        DpType.Int = overviewCircuitService.createDpType('Int');
        DpType.Bool = overviewCircuitService.createDpType('Bool');

        var Position = overviewCircuitService.getPositions();

        var HeatpumpStates = {};
        function getHeatpumpStateByValue(value) {
            return getServerEnumByValue(HeatpumpStates, value);
        }

        var HeatpumpBufferSystems = {};
        function getHeatpumpBufferStateByValue(value) {
            return getServerEnumByValue(HeatpumpBufferSystems, value);
        }

        var HeatingCircuitStates = {};
        function getHeatingCircuitStateByValue(value) {
            return getServerEnumByValue(HeatingCircuitStates, value);
        }

        function getServerEnumByValue(enumDict, value) {
            for (var key in enumDict) {
                if (enumDict.hasOwnProperty(key)
                    && enumDict[key].EnumValueKeyNumber === value) {
                        return enumDict[key];
                }
            }
            $log.warn('No ' + enumDict + ' found!');
        }















        var favoriteObject = {
            favoriteType : 'MenuEntry',
            favoriteObject:
                __MenuEntry.$buildRaw({
                    "$type" : "BMS.Shared.Model.System.FavoriteCustomAction, BMS.Shared",
                    "MenuEntryType": 3, // For Toggle Favorite to check MenuEntryType.
                    "MenuEntryId": '46b9a241-4da9-40b5-aa55-7c3c7a234b4b',
                    "DeviceId": actualDevice.DeviceId,
                    'CustomActionName': 'OverviewHeatingCircuit',
                    'DisplayName': $translate.instant('NAV_OverviewHeatingCircuit'),
                    'ImageName': 'hk-info',
                    $UI:{}
                })
            };
        viewMenuBarService.setFavorite(favoriteObject);
        viewMenuBarService.setButtons({});

        var Colors = overviewCircuitService.getColors();

        overviewCircuitService.setFabricDefaults();



        var canvas = this.__canvas = new fabric.StaticCanvas('canvas', { skipTargetFind:true });

        canvas.labels = {};

        canvas.constants = {};
        canvas.constants.initScale = 1.0;
        canvas.constants.srcRoot = './images/overview_heating_circuit/';

        var hkgs = {};
        var pipes = {};
        var arrows = {};
        var speicher = [];



        canvas.canvasInit = canvasInit;

        canvas.animations = {};
        canvas.animations.topLight = {};
        canvas.animations.topLight.isBlinking = false;
        canvas.animations.bottomLight = {};
        canvas.animations.bottomLight.isBlinking = false;
        canvas.animations.dleLight = {};
        canvas.animations.dleLight.isBlinking = false;

        canvas.animations.topLight.startBlinking = function(left, top) {
            if (canvas.animations.topLight.isBlinking === false) {
                canvas.animations.topLight.isBlinking = true;
                createLightAndSetTimer(canvas.animations.topLight, left, top);
            }
        };
        canvas.animations.topLight.stopBlinking = function () {
            if (canvas.animations.topLight.isBlinking === true) {
                canvas.animations.topLight.isBlinking = false;
                hideLightAndRemoveTimer(canvas.animations.topLight);
            }
        };
        canvas.animations.bottomLight.startBlinking = function(left, top) {
            if (canvas.animations.bottomLight.isBlinking === false) {
                canvas.animations.bottomLight.isBlinking = true;
                createLightAndSetTimer(canvas.animations.bottomLight, left, top);
            }
        };
        canvas.animations.bottomLight.stopBlinking = function () {
            if (canvas.animations.bottomLight.isBlinking === true) {
                canvas.animations.bottomLight.isBlinking = false;
                hideLightAndRemoveTimer(canvas.animations.bottomLight);
            }
        };
        canvas.animations.dleLight.startBlinking = function(left, top) {
            if (canvas.animations.dleLight.isBlinking === false) {
                canvas.animations.dleLight.isBlinking = true;
                createLightAndSetTimer(canvas.animations.dleLight, left, top);
            }
        };
        canvas.animations.dleLight.stopBlinking = function () {
            if (canvas.animations.dleLight.isBlinking === true) {
                canvas.animations.dleLight.isBlinking = false;
                hideLightAndRemoveTimer(canvas.animations.dleLight);
            }
        };

        vm.infoBar = {};

        $rootScope.$on('$locationChangeStart', function() {
            if (canvas.animations.topLight !== undefined) {
                canvas.animations.topLight.stopBlinking();
            }
            if (canvas.animations.bottomLight !== undefined) {
                canvas.animations.bottomLight.stopBlinking();
            }
            if (canvas.animations.dleLight !== undefined) {
                canvas.animations.dleLight.stopBlinking();
            }
            if (canvas.deactivateAll !== undefined) {
                canvas.deactivateAll();
            }
        });

        function setCancelingTimeout(fn, delay) {
            var promise = $timeout(fn, delay);
            var deregister = $rootScope.$on('$locationChangeStart', function() {
                $timeout.cancel(promise);
            });
            promise.then(deregister, deregister);
        }

        this.$onInit = function () {
            var api = new API();
            deviceTypes = ENUM.getDeviceTypesByFilter(1);

            var hpEnumsFilter = {
                "FilterConfigurations":
                [
                    { "EnumName": "HeatpumpState", FilterProfile: 1 },
                    { "EnumName": "HeatpumpBufferSystem", FilterProfile: 1 },
                    { "EnumName": "HeatingCircuitState", FilterProfile: 1 }
                ]
            };
            var hpEnumsPromise = api.System.ResolveEnums(hpEnumsFilter).$promise;

            hpEnumsPromise
                .then(function (data) {
                    fillLocalEnum(data[0].Metadata, HeatpumpStates);

                    /* If HeatpumpBufferSystem enum available */
                    if (Object.keys(data[1].Metadata).length) {
                        fillLocalEnum(data[1].Metadata, HeatpumpBufferSystems);
                    } else {
                        HeatpumpBufferSystems = {
                            "Unknown": {
                                "EnumValueKey": "Unknown",
                                "EnumValueKeyNumber": 0,
                                "DisplayName": "Unknown"
                            },
                            "Without_Buffer": {
                                "EnumValueKey": "Without_Buffer",
                                "EnumValueKeyNumber": 1,
                                "DisplayName": "Without_Buffer"
                            },
                            "Layered_Buffer_Storage_Or_Hygienic_Storage": {
                                "EnumValueKey": "Layered_Buffer_Storage_Or_Hygienic_Storage",
                                "EnumValueKeyNumber": 2,
                                "DisplayName": "Layered_Buffer_Storage_Or_Hygienic_Storage"
                            },
                            "Buffered_Storage": {
                                "EnumValueKey": "Buffered_Storage",
                                "EnumValueKeyNumber": 3,
                                "DisplayName": "Buffered_Storage"
                            },
                            "Two_Buffer_System": {
                                "EnumValueKey": "Two_Buffer_System",
                                "EnumValueKeyNumber": 4,
                                "DisplayName": "Two_Buffer_System"
                            }
                        };
                    }

                    /* If HeatingCircuitState enum available */
                    if (Object.keys(data[2].Metadata).length) {
                        fillLocalEnum(data[2].Metadata, HeatingCircuitStates);
                    } else {
                        HeatingCircuitStates = {
                            "Off": {
                                "EnumValueKey": "Off",
                                "EnumValueKeyNumber": 0,
                                "DisplayName": "Aus"
                            },
                            "Heating": {
                                "EnumValueKey": "Heating",
                                "EnumValueKeyNumber": 1,
                                "DisplayName": "Heizen"
                            },
                            "Cooling": {
                                "EnumValueKey": "Cooling",
                                "EnumValueKeyNumber": 2,
                                "DisplayName": "Kühlen"
                            }
                        };
                    }

                    canvas.canvasInit();
                    activateLoadDeviceTypesInterval();
                    if (vm.DeviceConfigVersion >= 6) {
                        activateHeatpumpStateLastChangedTimer();
                    }

                    loadDeviceTypes().then(function() {
                        activateLoadConfigsTimer();
                        activateLoadDpValuesTimer();
                    });
                });

        };

        function fillLocalEnum(serverEnum, localEnum) {
            for (var itr in serverEnum) {
                if (serverEnum.hasOwnProperty(itr))    {
                    localEnum[serverEnum[itr].EnumValueKey] = serverEnum[itr];
                }
            }
        }

        function showImage(image, showOnTop) {
            if (image.obj === undefined) {
                loadImage(image, showOnTop);
            }
            if (image.obj !== undefined) {
                image.obj.set({'visible':true});
            }
        }
        // function hideImage(image) {
        //     if (image.obj !== undefined) {
        //         image.obj.set({'visible':false});
        //     }
        // }
        function loadImage(image, showOnTop) {
            fabric.Image.fromURL(image.src, function (oImg) {
                // oImg.scale(1.2);
                image.obj = oImg;
                canvas.add(oImg);
                if (!showOnTop) {
                    canvas.sendToBack(oImg);
                }
            },
            {
                left: (image.left ? image.left : 0),
                top: (image.top ? image.top : 0)
            });
        }






        function canvasInit() {
            canvas.setBackgroundColor(Colors.background.value, canvas.renderAll.bind(canvas), {
               left: 0,
               top: 0
            });

            // (function render() {
            //     canvas.renderAll();
            //     fabric.util.requestAnimFrame(render);
            // })();
        }

        vm.textObjects = {};
        canvas.labels.setText = function(dp, labelLeft, labelTop) {
            if (dp === undefined || dp === null) { return; }

            if (dp._ScreenValue === undefined) {
                if (deepCompare([dp._Type, DpType.Float])) {
                    dp._ScreenValue = roundToTwoFixedString(dp.Value)
                                        + (dp._Unit !== undefined && dp._Unit !== '' ? ' ' + dp._Unit : '');
                }
                else if (deepCompare([dp._Type, DpType.Int])) {
                    dp._ScreenValue = dp.Value
                                        + (dp._Unit !== undefined && dp._Unit !== '' ? ' ' + dp._Unit : '');
                }
            }


            if (vm.textObjects[dp.DatapointConfigId] === undefined) {
                var backWidth = (dp._LabelWidth === undefined ? 78 : dp._LabelWidth);
                var paddingRight = 0;
                if (!dp._IsCentered) {
                    backWidth -= 3;
                    paddingRight = 3;
                }

                vm.textObjects[dp.DatapointConfigId] = {text: dp._ScreenValue, top: labelTop + 2, left: labelLeft, width: backWidth, paddingRight: paddingRight};
                vm.textObjects[dp.DatapointConfigId].textAlign = dp._IsCentered ? 'center' : 'right';
                vm.textObjects[dp.DatapointConfigId].backgroundColor = dp._LabelColor === undefined ? Colors.green.value : dp._LabelColor;
            } else {
                vm.textObjects[dp.DatapointConfigId].text = dp._ScreenValue;
                vm.textObjects[dp.DatapointConfigId].textAlign = dp._IsCentered ? 'center' : 'right';
                vm.textObjects[dp.DatapointConfigId].backgroundColor = dp._LabelColor === undefined ? Colors.green.value : dp._LabelColor;
            }



        };
        canvas.labels.removeText = function(dp) {
            delete vm.textObjects[dp.DatapointConfigId];
        };

        function createLightAndSetTimer(light, left, top) {
            if (light.obj === undefined) {
                light.obj = new fabric.Circle({
                    radius: 9.7,
                    fill: 'rgba(255,0,0,0.0)',
                    left: left,
                    top: top,
                    scale: canvas.constants.initScale
                });
                canvas.add(light.obj);
            }

            lightAnimation(light);
            light.blinkingInterval = $interval(lightAnimation.bind(null, light), 1000);
        }

        function lightAnimation(light) {
            light.obj.set({ fill: 'rgba(255,0,0,1.0)' });
            canvas.bringToFront(light.obj);
            setCancelingTimeout(function () {
                light.obj.set({ fill: 'rgba(255,0,0,0.0)' });
                canvas.renderAll();
            }, 500);
            canvas.renderAll();
        }

        function hideLightAndRemoveTimer(light) {
            $interval.cancel(light.blinkingInterval);
            if (light.obj !== undefined) {
                light.obj.set({ fill: 'rgba(255,0,0,0.0)' });
            }
        }


















































        function createPipe(left, top, length, position, color) {
            return overviewCircuitService.createPipe(left, top, length, position, color, 8);
        }
        function createBridge(left, top, radius, angle, color) {
            return overviewCircuitService.createBridge(left, top, radius, angle, color, 8);
        }
        function createArrow(fromPoint, toPoint) {
            return overviewCircuitService.createArrow(fromPoint, toPoint);
        }































        var previousPump = {};
        var previousPumpBufferSystem = {};
        function loadDeviceTypes() {
            let defer = $q.defer();

            var api = new API();

            var xChangeDynamicDevicesPromise;
            var xChangeCompactDevicesPromise;
            for (var key in deviceTypes) {
                if (deviceTypes.hasOwnProperty(key)) {
                    var value = deviceTypes[key];

                    if (value.EnumValueKey === 'XChangeDynamic') {
                        xChangeDynamicDevicesPromise = api.Device.GetDevicesByType({ 'DeviceType': deviceTypes[key].EnumValueKeyNumber, 'WithDetails': false }).$promise;
                    }
                    else if (value.EnumValueKey === 'XChangeCompact') {
                        xChangeCompactDevicesPromise = api.Device.GetDevicesByType({ 'DeviceType': deviceTypes[key].EnumValueKeyNumber, 'WithDetails': false }).$promise;
                    }
                }
            }



            $q.all([xChangeDynamicDevicesPromise, xChangeCompactDevicesPromise])
                .then(function (data) {
                    vm.pump = overviewCircuitService.extractPump(data, actualDevice);

                    detectPumpBufferSystemPromise(vm.pump)
                    .then(function(hpBuffer) {

                        if (angular.equals(previousPumpBufferSystem, hpBuffer)
                            && angular.equals(previousPump, vm.pump)) {
                            return;
                        } else {
                            previousPump = angular.copy(vm.pump);
                            previousPumpBufferSystem = angular.copy(hpBuffer);
                            reinitiateUI();
                            var circuits = detectCircuits(vm.pump);
                            initHkgs(circuits);
                        }

                        if (hpBuffer === HeatpumpBufferSystems.Unknown
                            || hpBuffer === HeatpumpBufferSystems.Layered_Buffer_Storage_Or_Hygienic_Storage
                            || hpBuffer === HeatpumpBufferSystems.Two_Buffer_System
                            || hpBuffer === HeatpumpBufferSystems.Buffered_Storage
                            || hpBuffer === HeatpumpBufferSystems.Without_Buffer) {
                                activateCorrectSystem(hpBuffer);
                                hpBufferSystem = hpBuffer;

                                prepareDatapoints(hpBuffer)
                                .then(function(preparedDatapoints) {
                                    vm.dataPoints = preparedDatapoints;

                                    $q.all(
                                        [
                                            loadDatapointDataPromise(vm.dataPoints),
                                            loadConfigsPromise(vm.dataPoints),
                                            versionMappingService.recallFunction('PumpeMK1Dp'),
                                            versionMappingService.recallFunction('PumpeMK2Dp'),
                                            versionMappingService.recallFunction('PumpeMK3Dp')
                                        ]
                                    )
                                    .then(function(data) {
                                        vm.dpValues = data[0];
                                        vm.dpConfigs = data[1];

                                        hkgs.g1.labels.PumpeMKXDp.id = data[2]().DatapointConfigId;
                                        hkgs.g2.labels.PumpeMKXDp.id = data[3]().DatapointConfigId;
                                        hkgs.g3.labels.PumpeMKXDp.id = data[4]().DatapointConfigId;

                                        processData();

                                        defer.resolve();
                                    });
                                });
                        }
                        else {
                            var notImplementedYetDp = { DatapointConfigId: 'notImplementedYet' };
                            notImplementedYetDp._IsCentered = true;
                            notImplementedYetDp._LabelWidth = 960;
                            notImplementedYetDp._LabelColor = 'orange';
                            notImplementedYetDp._ScreenValue = $translate.instant('CUSTOM_OverviewHeatingCircuit_SelectedBufferType') + ': ' + $translate.instant('ERROR_NotImplementedYet');
                            canvas.labels.setText(notImplementedYetDp, 0, 236);
                            stopLoadTimers.configs = true;
                            stopLoadTimers.dpValues = true;
                            stopLoadTimers.deviceTypes = true;
                            stopLoadTimers.heatpumpStateLastChanged = true;
                            aktivateDebugFunctions();

                            defer.resolve();
                        }


                    });

                });

            return defer.promise;
        }

        function reinitiateUI() {
            ranOnce = false;
            vm.textObjects = {};
            canvas.clear();

            canvas.setBackgroundColor(Colors.background.value, canvas.renderAll.bind(canvas), {
                left: 0,
                top: 0
            });
        }

        function activateLoadDeviceTypesInterval() {
            $timeout(function() {
                if (stopLoadTimers.deviceTypes) {
                    return;
                }
                activateLoadDeviceTypesInterval();
            }, 6000);

        }

        function detectCircuits(pump) {
            var mkCircuits = {
                mk1Active: false,
                mk2Active: false,
                mk3Active: false
            };
            if (pump.DeviceOptions !== undefined) {
                for (var option in pump.DeviceOptions) {
                    if (pump.DeviceOptions.hasOwnProperty(option) && pump.DeviceOptions[option].IsActivated) {
                        var pumpOption = pump.DeviceOptions[option];
                        if (areGuidsEqual(pumpOption.OptionId, xCenterConfig.deviceOptions.Heatpump_MK1)) { mkCircuits.mk1Active = true; }
                        else if (areGuidsEqual(pumpOption.OptionId, xCenterConfig.deviceOptions.Heatpump_MK2)) { mkCircuits.mk2Active = true; }
                        else if (areGuidsEqual(pumpOption.OptionId, xCenterConfig.deviceOptions.Heatpump_MK3)) { mkCircuits.mk3Active = true; }
                    }
                }
            }
            return mkCircuits;
        }

        function detectPumpBufferSystemPromise(device) {
            var defer = $q.defer();

            if (device.ConfigVersion && device.ConfigVersion > 3) {
                versionMappingService.recallFunction('Pufferspeichertyp')
                .then(function(getDp) {
                    var dataPoint = [{'DeviceId': device.DeviceId, 'DatapointConfigId': getDp().DatapointConfigId}];

                    var api = new API();
                    var readValuesParams = { "DatapointValues": dataPoint, IgnoreErrors: false };
                    api.Datapoint.ReadValues(readValuesParams).$promise
                    .then(function (resp) {
                        defer.resolve(getHeatpumpBufferStateByValue(resp[0].Value));
                    }, function () {
                        $log.error('Error: Cannot call ReadValues!');
                    });
                });
            } else {
                defer.resolve($q.when(HeatpumpBufferSystems.Layered_Buffer_Storage_Or_Hygienic_Storage));
            }

            return defer.promise;
        }

        function initHkgs(circuits) {
            hkgs.g1 = {
                id: 'hkg1',
                number: 1,
                active: false,
                statusPumpe: false,
                image: {
                    src: canvas.constants.srcRoot + 'shared/hkg1_2.png',
                    defaultTop: 172,
                    defaultLeft: 600
                },
                pipes: {
                    top: {
                        left: 676,
                        top: 401,
                        long: 96
                    },
                    bottom: {
                        left: 615,
                        top: 401
                    }
                },
                labels: {
                    PumpeMKXDp: {
                        top: 262,
                        left: 592
                    },
                    HP_MKXSollTempPanel: {
                        top: 28,
                        left: 640,
                        name: 'HP_MK1SollTempPanel'
                    },
                    HP_MKXIstTemp: {
                        top: 54,
                        left: 640,
                        name: 'HP_MK1IstTemp'
                    },
                    MKXIst3WegeVentil: {
                        top: 288,
                        left: 592,
                        name: 'MK1Ist3WegeVentil'
                    }
                }
            };
            hkgs.g2 = {
                id: 'hkg2',
                number: 2,
                active: false,
                statusPumpe: false,
                image: {
                    src: canvas.constants.srcRoot + 'shared/hkg1_2.png',
                    defaultTop: 172,
                    defaultLeft: 728
                },
                pipes: {
                    top: {
                        left: 804,
                        top: 401,
                        long: 224
                    },
                    bottom: {
                        left: 742,
                        top: 401
                    }
                },
                labels: {
                    PumpeMKXDp: {
                        top: 262,
                        left: 714
                    },
                    HP_MKXSollTempPanel: {
                        top: 28,
                        left: 767,
                        name: 'HP_MK2SollTempPanel'
                    },
                    HP_MKXIstTemp: {
                        top: 54,
                        left: 767,
                        name: 'HP_MK2IstTemp'
                    },
                    MKXIst3WegeVentil: {
                        top: 288,
                        left: 714,
                        name: 'MK2Ist3WegeVentil'
                    }
                }
            };
            hkgs.g3 = {
                id: 'hkg3',
                number: 3,
                active: false,
                statusPumpe: false,
                image: {
                    src: canvas.constants.srcRoot + 'shared/hkg3.png',
                    defaultTop: 172,
                    defaultLeft: 849
                },
                pipes: {
                    top: {
                        left: 924,
                        top: 401,
                        long: 345
                    },
                    bottom: {
                        left: 863,
                        top: 401
                    }
                },
                labels: {
                    PumpeMKXDp: {
                        top: 262,
                        left: 840
                    }
                }
            };
            hkgs.fetchActiveGroups = function() {
                var ag = [];

                for (var group in hkgs) {
                    if (hkgs.hasOwnProperty(group) && hkgs[group].active) {
                        ag.push(group);
                    }
                }

                return ag;
            };
            hkgs.isAnyGroupCooling = function() {
                return (
                    (hkgs.g1.active && hkgs.g1.heatingCircuitState === HeatingCircuitStates.Cooling)
                 || (hkgs.g2.active && hkgs.g2.heatingCircuitState === HeatingCircuitStates.Cooling)
                 || (hkgs.g3.active && hkgs.g3.heatingCircuitState === HeatingCircuitStates.Cooling)
                );
            };
            hkgs.shouldDisplayGrayLines = function() {
                if (hkgs.g1.statusPumpe || hkgs.g2.statusPumpe || hkgs.g3.statusPumpe) {
                    return false;
                }
                return true;
            };

            hkgs.g1.active = circuits.mk1Active;
            hkgs.g2.active = circuits.mk2Active;
            hkgs.g3.active = circuits.mk3Active;
        }

        function activateCorrectSystem(heatpumpBufferSystem) {
            pipes = {
                right: {
                    top: [],
                    bottom: []
                },
                left: {
                    first: [],
                    second: [],
                    third: [],
                    fourth: [],
                    shared: [],
                    // entry pipes for HK4
                    fifth: [],
                    sixth: []
                }
            };
            pipes.setColors = function(pipesArray, color) {
                overviewCircuitService.pipes.setColors(pipesArray, color);
            };
            pipes.hide = function(pipe) {
                overviewCircuitService.pipes.hide(pipe);
            };
            pipes.show = function(pipe) {
                overviewCircuitService.pipes.show(pipe);
            };

            arrows.plg = {
                top: [],
                bottom: []
            };
            arrows.hkgs = {
                left: [],
                right: [],
            };
            arrows.setColors = function(arrowsArray, color) {
                overviewCircuitService.arrows.setColors(arrowsArray, color);
            };
            speicher = [];






            if (heatpumpBufferSystem === HeatpumpBufferSystems.Unknown
                || heatpumpBufferSystem === HeatpumpBufferSystems.Layered_Buffer_Storage_Or_Hygienic_Storage) {
                    speicher.push({'image': {
                        src: canvas.constants.srcRoot + 'schichtenspeicher.png',
                        top: 14,
                        left: 356
                    }});

                    showImage(speicher[0].image);

                    var pufferladegruppe = {
                        src: canvas.constants.srcRoot + 'pufferladegruppe_schichtenspeicher.png',
                        top: 171,
                        left: 91
                    };
                    showImage(pufferladegruppe);



                    pipes.left.first.push(createPipe(110,53,119,Position.Vertical));
                    pipes.left.first.push(createPipe(110,51,251,Position.Horizontal));

                    pipes.left.first.forEach(function(pipe) { canvas.add(pipe.body); });
                    pipes.left.first.forEach(function(pipe) { canvas.add(pipe.gradient); });


                    pipes.left.second.push(createPipe(173,83,89,Position.Vertical));
                    pipes.left.second.push(createPipe(173,81,183,Position.Horizontal));
                    pipes.left.second.push(createPipe(348,83,198,Position.Vertical));
                    pipes.left.second.push(createPipe(348,273,13,Position.Horizontal));

                    pipes.left.second.forEach(function(pipe) { canvas.add(pipe.body); });
                    pipes.left.second.forEach(function(pipe) { canvas.add(pipe.gradient); });


                    pipes.left.third.push(createPipe(234,153,19,Position.Vertical));
                    pipes.left.third.push(createPipe(234,151,92,Position.Horizontal));
                    pipes.left.third.push(createPipe(318,153,293,Position.Vertical));
                    pipes.left.third.push(createPipe(318,438,43,Position.Horizontal));

                    pipes.left.third.forEach(function(pipe) { canvas.add(pipe.body); });
                    pipes.left.third.forEach(function(pipe) { canvas.add(pipe.gradient); });


                    pipes.left.fourth.push(createPipe(297,119,53,Position.Vertical));
                    pipes.left.fourth.push(createPipe(297,117,44,Position.Horizontal));
                    pipes.left.fourth.push(createPipe(333,119,118,Position.Vertical));
                    pipes.left.fourth.push(createPipe(333,229,27,Position.Horizontal));

                    pipes.left.fourth.forEach(function(pipe) { canvas.add(pipe.body); });
                    pipes.left.fourth.forEach(function(pipe) { canvas.add(pipe.gradient); });



                    arrows.plg.top.push(createArrow(
                        { x: pufferladegruppe.left - 50, y: pufferladegruppe.top + 154 },
                        { x: pufferladegruppe.left - 2, y: pufferladegruppe.top + 154 }
                    ));
                    arrows.plg.bottom.push(createArrow(
                        { x: pufferladegruppe.left - 39, y: pufferladegruppe.top + 215 },
                        { x: pufferladegruppe.left - 87, y: pufferladegruppe.top + 215 }
                    ));

            }
            else if (heatpumpBufferSystem === HeatpumpBufferSystems.Two_Buffer_System) {
                speicher.push({
                    'image': {
                        src: canvas.constants.srcRoot + 'trinkwasserspeicher_mitlicht.png',
                        top: 7,
                        left: 432
                    }
                });
                speicher.push({
                    'image': {
                        src: canvas.constants.srcRoot + 'pufferspeicher.png',
                        top: 256,
                        left: 432
                    }
                });

                showImage(speicher[0].image);
                showImage(speicher[1].image);

                var pufferladepumpeUber = {
                    src: canvas.constants.srcRoot + 'shared/pufferladepumpe_uber.png',
                    top: 81,
                    left: 91
                };
                showImage(pufferladepumpeUber);

                var pufferladepumpeUnter = {
                    src: canvas.constants.srcRoot + 'shared/pufferladepumpe_unter.png',
                    top: 193,
                    left: 91
                };
                showImage(pufferladepumpeUnter);


    //             var circle = new fabric.Circle({
    //                 radius: 30, fill: 'transparent', left: 150, top: 403, stroke: '#B28632', strokeWidth: 10, startAngle: 0,
    // endAngle: Math.PI, angle: -90
    //             });
    //             circle.setGradient('stroke', {
    //                 x1: 0,
    //                 y1: 0,
    //                 x2: 0,
    //                 y2: 30,
    //                 colorStops: Colors.white.pipeGradient
    //             });
    //             canvas.add(circle);



                pipes.left.first.push(createPipe(312,92,23,Position.Horizontal));
                pipes.left.first.push(createPipe(327,40,60,Position.Vertical));
                pipes.left.first.push(createPipe(327,39,106,Position.Horizontal));

                pipes.left.first.forEach(function(pipe) { canvas.add(pipe.body); });
                pipes.left.first.forEach(function(pipe) { canvas.add(pipe.gradient); });




                pipes.left.shared.push(createPipe(312,210,9,Position.Horizontal));
                pipes.left.shared.unshift(createPipe(316,210,19,Position.Horizontal));


                // three way ventil
                pipes.left.second.unshift(createPipe(330,210,17,Position.Horizontal));
                pipes.left.second.push(createPipe(342,210,91,Position.Horizontal));


                pipes.left.third.push(createPipe(312,151,70,Position.Horizontal));
                pipes.left.third.push(createPipe(374,153,51,Position.Vertical));
                pipes.left.third.push(createBridge(357,234,15,270));
                pipes.left.third.push(createPipe(374,225,58,Position.Vertical));
                pipes.left.third.push(createPipe(374,275,60,Position.Horizontal));



                // three way ventil
                pipes.left.fourth.unshift(createPipe(327,216,13,Position.Vertical));
                pipes.left.fourth.push(createPipe(327,225,243,Position.Vertical));
                pipes.left.fourth.push(createPipe(327,460,106,Position.Horizontal));


                pipes.left.shared.forEach(function(pipe) { canvas.add(pipe.body); });
                pipes.left.second.forEach(function(pipe) { canvas.add(pipe.body); });
                pipes.left.fourth.forEach(function(pipe) { canvas.add(pipe.body); });

                pipes.left.shared.forEach(function(pipe) { canvas.add(pipe.gradient); });
                pipes.left.second.forEach(function(pipe) { canvas.add(pipe.gradient); });
                pipes.left.fourth.forEach(function(pipe) { canvas.add(pipe.gradient); });

                pipes.left.third.forEach(function(pipe) { canvas.add(pipe.body); });
                pipes.left.third.forEach(function(pipe) { canvas.add(pipe.gradient); });


                arrows.plg.top.push(createArrow(
                    { x: pufferladepumpeUber.left - 50, y: pufferladepumpeUber.top + 73 },
                    { x: pufferladepumpeUber.left - 2, y: pufferladepumpeUber.top + 73 }
                ));
                arrows.plg.bottom.push(createArrow(
                    { x: pufferladepumpeUber.left - 39, y: pufferladepumpeUber.top + 134 },
                    { x: pufferladepumpeUber.left - 87, y: pufferladepumpeUber.top + 134 }
                ));

            }
            else if (heatpumpBufferSystem === HeatpumpBufferSystems.Buffered_Storage) {
                speicher.push({'image': {
                    src: canvas.constants.srcRoot + 'pufferspeicher_gross.png',
                    top: 19,
                    left: 362
                }});

                showImage(speicher[0].image);

                var pufferladepumpe = {
                    src: canvas.constants.srcRoot + 'shared/pufferladepumpe_unter.png',
                    top: 245,
                    left: 91
                };
                showImage(pufferladepumpe);

                let rohr = {
                    src: canvas.constants.srcRoot + 'shared/rohr.png',
                    top: 215,
                    left: 138
                };
                showImage(rohr);


                pipes.left.first.push(createPipe(93,225,44,Position.Horizontal));
                pipes.left.first.push(createPipe(230,225,118,Position.Horizontal));
                pipes.left.first.push(createPipe(341,52,181,Position.Vertical));
                pipes.left.first.push(createPipe(341,50,24,Position.Horizontal));

                pipes.left.first.forEach(function(pipe) { canvas.add(pipe.body); });
                pipes.left.first.forEach(function(pipe) { canvas.add(pipe.gradient); });


                pipes.left.second.push(createPipe(312,262,36,Position.Horizontal));
                pipes.left.second.push(createPipe(340,264,174,Position.Vertical));
                pipes.left.second.push(createPipe(340,430,24,Position.Horizontal));

                pipes.left.second.forEach(function(pipe) { canvas.add(pipe.body); });
                pipes.left.second.forEach(function(pipe) { canvas.add(pipe.gradient); });



                arrows.plg.top.push(createArrow(
                    { x: pufferladepumpe.left - 50, y: pufferladepumpe.top - 16 },
                    { x: pufferladepumpe.left - 2, y: pufferladepumpe.top - 16 }
                ));
                arrows.plg.bottom.push(createArrow(
                    { x: pufferladepumpe.left - 39, y: pufferladepumpe.top + 22 },
                    { x: pufferladepumpe.left - 87, y: pufferladepumpe.top + 22 }
                ));


            }
            else if (heatpumpBufferSystem === HeatpumpBufferSystems.Without_Buffer) {
                speicher.push({
                    'image': {
                        src: canvas.constants.srcRoot + 'trinkwasserspeicher_ohnelicht.png',
                        top: 10,
                        left: 752
                    }
                });
                showImage(speicher[0].image);

                var radiator = {
                    src: canvas.constants.srcRoot + 'radiator.png',
                    top: 280,
                    left: 732
                };
                showImage(radiator);

                let pufferladepumpeUber = {
                    src: canvas.constants.srcRoot + 'shared/pufferladepumpe_uber.png',
                    top: 81,
                    left: 391
                };
                showImage(pufferladepumpeUber);

                let pufferladepumpeUnter = {
                    src: canvas.constants.srcRoot + 'shared/pufferladepumpe_unter.png',
                    top: 193,
                    left: 391
                };
                showImage(pufferladepumpeUnter);



                pipes.left.first.push(createPipe(612,92,23,Position.Horizontal));
                pipes.left.first.push(createPipe(627,40,60,Position.Vertical));
                pipes.left.first.push(createPipe(627,39,126,Position.Horizontal));

                pipes.left.first.forEach(function(pipe) { canvas.add(pipe.body); });
                pipes.left.first.forEach(function(pipe) { canvas.add(pipe.gradient); });




                pipes.left.shared.push(createPipe(612,210,9,Position.Horizontal));
                pipes.left.shared.unshift(createPipe(616,210,19,Position.Horizontal));


                // three way ventil
                pipes.left.second.unshift(createPipe(630,210,17,Position.Horizontal));
                pipes.left.second.push(createPipe(642,210,111,Position.Horizontal));


                pipes.left.third.push(createPipe(612,151,70,Position.Horizontal));
                pipes.left.third.push(createPipe(674,153,51,Position.Vertical));
                pipes.left.third.push(createBridge(657,234,15,270));
                pipes.left.third.push(createPipe(674,225,107,Position.Vertical));
                pipes.left.third.push(createPipe(674,325,60,Position.Horizontal));



                // three way ventil
                pipes.left.fourth.unshift(createPipe(627,216,13,Position.Vertical));
                pipes.left.fourth.push(createPipe(627,225,200,Position.Vertical));
                pipes.left.fourth.push(createPipe(627,417,106,Position.Horizontal));


                pipes.left.shared.forEach(function(pipe) { canvas.add(pipe.body); });
                pipes.left.second.forEach(function(pipe) { canvas.add(pipe.body); });
                pipes.left.fourth.forEach(function(pipe) { canvas.add(pipe.body); });

                pipes.left.shared.forEach(function(pipe) { canvas.add(pipe.gradient); });
                pipes.left.second.forEach(function(pipe) { canvas.add(pipe.gradient); });
                pipes.left.fourth.forEach(function(pipe) { canvas.add(pipe.gradient); });


                pipes.left.third.forEach(function(pipe) { canvas.add(pipe.body); });
                pipes.left.third.forEach(function(pipe) { canvas.add(pipe.gradient); });


                pipes.left.fifth.push(createPipe(110,92,150,Position.Horizontal));
                pipes.left.fifth.push(createPipe(252,93,60,Position.Vertical));
                pipes.left.fifth.push(createPipe(260,150,132,Position.Horizontal));

                pipes.left.fifth.forEach(function(pipe) { canvas.add(pipe.body); });
                pipes.left.fifth.forEach(function(pipe) { canvas.add(pipe.gradient); });

                pipes.left.sixth.push(createPipe(110,210,282,Position.Horizontal));

                pipes.left.sixth.forEach(function(pipe) { canvas.add(pipe.body); });
                pipes.left.sixth.forEach(function(pipe) { canvas.add(pipe.gradient); });

                var durchlauferhitzer = {
                    src: canvas.constants.srcRoot + 'durchlauferhitzer.png',
                    top: 132,
                    left: 170
                };
                showImage(durchlauferhitzer, true);

                arrows.plg.top.push(createArrow(
                    { x: 48, y: pufferladepumpeUber.top + 15 },
                    { x: 96, y: pufferladepumpeUber.top + 15 }
                ));
                arrows.plg.bottom.push(createArrow(
                    { x: 56, y: pufferladepumpeUber.top + 134 },
                    { x: 8, y: pufferladepumpeUber.top + 134 }
                ));
            }

            arrows.plg.top.forEach(function(arrow) {
                canvas.add(arrow);
            });
            arrows.plg.bottom.forEach(function(arrow) {
                canvas.add(arrow);
            });
        }

        function loadDatapointDataPromise(dataPoints) {
            for (var point in dataPoints) {
                if (dataPoints.hasOwnProperty(point)) {
                    dataPoints[point].DeviceId = vm.pump.DeviceId;
                }
            }

            var api = new API();
            var readValuesParams = { "DatapointValues": reduceRequestParams(dataPoints), IgnoreErrors: false };
            return api.Datapoint.ReadValues(readValuesParams).$promise;
        }

        function loadConfigsPromise(dataPoints) {
            var datapointConfigIds = [];
            for (var point2 in dataPoints) {
                if (dataPoints.hasOwnProperty(point2)) {
                    datapointConfigIds.push(dataPoints[point2].DatapointConfigId);
                }
            }
            var getConfigsParams = {
                DeviceType: vm.pump.DeviceType,
                DeviceVersion: vm.pump.SoftwareVersion,
                DatapointConfigIds: datapointConfigIds,
                IgnoreNotExisting: false,
                OptionFilter:undefined
            };
            var api = new API();
            return api.Datapoint.GetConfigs(getConfigsParams).$promise;
        }

        function homeserverVersionUsable(version) {
            return frontEndSettingsService.getFrontendSettings()
            .then(function(settings) {
                if (versionMappingService.versionCompare(
                        settings.HomeServerVersion,
                        version,
                        { zeroExtend: true }
                    ) >= 0) {
                        return true;
                    }
                else {
                    return false;
                }
            });
        }

        function prepareDatapoints(hpBufferSystem) {
            let defer = $q.defer();

            var dataPoints = [];
            let promisses = [];

            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_AktuelleMotorleistungKW, _Type:DpType.Float});
            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_FanAktuelleLeistung, _Type:DpType.Float});
            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_TotalCOP, _Type:DpType.Float});
            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.Aussentemperatur_gemittelt, _Type:DpType.Float});

            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_AuslasstempLadekreis, _Type:DpType.Float});
            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_EinlasstempLadekreis, _Type:DpType.Float});

            promisses.push(versionMappingService.recallFunction('StatusPufferladepumpe'));
            promisses.push(versionMappingService.recallFunction('RegelsignalPufferladepumpe'));

            promisses.push(versionMappingService.recallFunction('EinschalthystereseHeating'));
            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_IstTempHW, _Type:DpType.Float});
            promisses.push(versionMappingService.recallFunction('AktuellerPuffersollwert'));

            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsInt.HP_HeatpumpState, _Type:DpType.Int});
            promisses.push(versionMappingService.recallFunction('AktuelleSollspreizungPufferladekreis'));
            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HPxyz_DurchflussIstLadekreis, _Type:DpType.Float});

            promisses.push(versionMappingService.recallFunction('ExternerWEZ1'));
            promisses.push(versionMappingService.recallFunction('ExternerWEZ2'));

            if (actualDevice.ConfigVersion && actualDevice.ConfigVersion >= 3) {
                promisses.push(versionMappingService.recallFunction('UsageExternalHeater1'));
                promisses.push(versionMappingService.recallFunction('UsageExternalHeater2'));
                promisses.push(versionMappingService.recallFunction('UsageExternalHeater3'));
                promisses.push(versionMappingService.recallFunction('ExternerWEZ3'));
            }

            if (hpBufferSystem === HeatpumpBufferSystems.Unknown
                || hpBufferSystem === HeatpumpBufferSystems.Layered_Buffer_Storage_Or_Hygienic_Storage
                || hpBufferSystem === HeatpumpBufferSystems.Two_Buffer_System) {
                    if (areCoolingFeaturesActivated())
                    {
                        dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsInt.ControlKermiMK3, _Type:DpType.Int});
                        dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.CoolingActualTemperatureBuffer, _Type:DpType.Float});

                        promisses.push(versionMappingService.recallFunction('SolltemperaturKühlen'));
                        promisses.push(versionMappingService.recallFunction('EinschalthystereseKuehlen'));
                    }

                    if (hkgs.g1.active) {
                        dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_MK1IstTemp, _Type:DpType.Float});
                        dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_MK1SollTempPanel, _Type:DpType.Float});
                        dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsInt.MK1Ist3WegeVentil, _Type:DpType.Int});
                        promisses.push(versionMappingService.recallFunction('PumpeMK1Dp'));
                        if (areCoolingFeaturesActivated()) {
                            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsInt.ControlKermiMK1, _Type:DpType.Int});
                        }
                    }
                    if (hkgs.g2.active) {
                        dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_MK2IstTemp, _Type:DpType.Float});
                        dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_MK2SollTempPanel, _Type:DpType.Float});
                        dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsInt.MK2Ist3WegeVentil, _Type:DpType.Int});
                        promisses.push(versionMappingService.recallFunction('PumpeMK2Dp'));
                        if (areCoolingFeaturesActivated()) {
                            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsInt.ControlKermiMK2, _Type:DpType.Int});
                        }
                    }

                    promisses.push(versionMappingService.recallFunction('PumpeMK3Dp'));
                    promisses.push(versionMappingService.recallFunction('UmschaltventilHeizenTWE'));

                    dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_TWETempIst, _Type:DpType.Float});
                    promisses.push(versionMappingService.recallFunction('EinschalthystereseTWE'));


                    dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_TWESoll, _Type:DpType.Float});

                    dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_TWESollEinmal, _Type:DpType.Float});
                    dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsBool.HP_General_TWE, _Type:DpType.Bool});
                    dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsBool.HP_EinmalTWEPanel, _Type:DpType.Bool});
            }
            else if (hpBufferSystem === HeatpumpBufferSystems.Buffered_Storage) {
                dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsInt.ControlKermiMK3, _Type:DpType.Int});
                dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.CoolingActualTemperatureBuffer, _Type:DpType.Float});
                promisses.push(versionMappingService.recallFunction('SolltemperaturKühlen'));
                promisses.push(versionMappingService.recallFunction('EinschalthystereseKuehlen'));

                if (hkgs.g1.active) {
                    dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_MK1IstTemp, _Type:DpType.Float});
                    dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_MK1SollTempPanel, _Type:DpType.Float});
                    dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsInt.MK1Ist3WegeVentil, _Type:DpType.Int});
                    promisses.push(versionMappingService.recallFunction('PumpeMK1Dp'));
                    dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsInt.ControlKermiMK1, _Type:DpType.Int});
                }
                if (hkgs.g2.active) {
                    dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_MK2IstTemp, _Type:DpType.Float});
                    dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_MK2SollTempPanel, _Type:DpType.Float});
                    dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsInt.MK2Ist3WegeVentil, _Type:DpType.Int});
                    promisses.push(versionMappingService.recallFunction('PumpeMK2Dp'));
                    dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsInt.ControlKermiMK2, _Type:DpType.Int});
                }

                promisses.push(versionMappingService.recallFunction('PumpeMK3Dp'));

                dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_TWESollEinmal, _Type:DpType.Float});
                dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsBool.HP_General_TWE, _Type:DpType.Bool});
                dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsBool.HP_EinmalTWEPanel, _Type:DpType.Bool});
            }
            else if (hpBufferSystem === HeatpumpBufferSystems.Without_Buffer) {
                dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.CoolingActualTemperatureBuffer, _Type:DpType.Float});

                promisses.push(versionMappingService.recallFunction('SolltemperaturKühlen'));
                promisses.push(versionMappingService.recallFunction('EinschalthystereseKuehlen'));
                promisses.push(versionMappingService.recallFunction('UmschaltventilHeizenTWE'));

                dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_TWETempIst, _Type:DpType.Float});
                promisses.push(versionMappingService.recallFunction('EinschalthystereseTWE'));
                dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_TWESoll, _Type:DpType.Float});
            }

            homeserverVersionUsable('1.5.45')
            .then((isUsable) => {
                if (isUsable) {
                    if (actualDevice.ConfigVersion && actualDevice.ConfigVersion >= 5) {
                        promisses.push(versionMappingService.recallFunction('ExternerFlowrateWEZ1'));
                        promisses.push(versionMappingService.recallFunction('ExternerFlowrateWEZ2'));
                        promisses.push(versionMappingService.recallFunction('ExternerFlowrateWEZ3'));
                    }
                }

                $q.all(promisses)
                .then(function(data) {
                    data.forEach(function(dpId) {
                        dataPoints.push(dpId());
                    });
                    defer.resolve(dataPoints);
                });
            });

            return defer.promise;
        }

        function areCoolingFeaturesActivated() {
            return (actualDevice.ConfigVersion && actualDevice.ConfigVersion > 3 ? true : false);
        }

        function activateLoadConfigsTimer() {
            $timeout(function() {
                if (stopLoadTimers.configs) {
                    return;
                }
                loadConfigsPromise(vm.dataPoints)
                .then(function(resp) {
                    vm.dpConfigs = resp;
                    activateLoadConfigsTimer();
                })
                .catch(function() {
                    $log.error('Unable to fetch datapoint configs!');
                    activateLoadConfigsTimer();
                });
            }, 25000);
        }

        function activateLoadDpValuesTimer() {
            $timeout(function() {
                if (stopLoadTimers.dpValues) {
                    return;
                }
                loadDatapointDataPromise(vm.dataPoints)
                .then(function(resp) {
                    vm.dpValues = resp;
                    activateLoadDpValuesTimer();
                    processData();
                })
                .catch(function() {
                    $log.error('Unable to fetch datapoint values!');
                    activateLoadDpValuesTimer();
                });
            }, 3000);
        }

        function activateHeatpumpStateLastChangedTimer() {
            if (stopLoadTimers.heatpumpStateLastChanged) {
                return;
            }
            const api = new API();
            const readValuesParams = {
                DatapointValues: [
                    {
                        DatapointConfigId: xCenterConfig.datapointsDateTime.HeatpumpStateLastChanged,
                        DeviceId: actualDevice.DeviceId,
                    },
                ],
                IgnoreErrors: true,
            };
            api.Datapoint.ReadValues(readValuesParams)
                .$promise.then((data) => {
                    const now = moment.utc();
                    const last = moment.utc(data[0].Value);
                    const diff = now.diff(last, true);
                    const dur = moment.duration(diff);
                    vm.infoBar.HeatpumpStateLastChanged = dur.hours() + ":" + (dur.minutes() >= 0 && dur.minutes() <= 9 ? '0' : '') + dur.minutes();
                    setTimeout(activateHeatpumpStateLastChangedTimer, 60000);
                })
                .catch(() => {
                    $log.error("Unable to fetch HeatpumpStateLastChanged!");
                    setTimeout(activateHeatpumpStateLastChangedTimer, 60000);
                });
        }

        function processData() {
            vm.updatedData = overviewCircuitService.updateDpValues(vm.dpValues, vm.dpConfigs, vm.dataPoints);
            vm.preparationComplete = true;
        }



        function reduceRequestParams(oldPoints) {
            var newPoints = [];

            for (var point in oldPoints) {
                if (oldPoints.hasOwnProperty(point)) {
                    newPoints.push(
                        {
                            'DatapointConfigId': oldPoints[point].DatapointConfigId,
                            'DeviceId': oldPoints[point].DeviceId
                        }
                    );
                }
            }

            return newPoints;
        }







        function areGuidsEqual(guidA, guidB) {
            if(guidA.replace(/[{}]/g, "").toLowerCase() === guidB.replace(/[{}]/g, "").toLowerCase()) {
                return true;
            }
            return false;
        }

        vm.preparationComplete = false;
        $scope.$watch('vm.preparationComplete', function (newValue) {
            vm.preparationComplete = false;
            if (newValue === true) {
                processDpValues(vm.updatedData);
            }
        }, true);

        function prepareHeizkreisGruppen() {
            var activeGroups = hkgs.fetchActiveGroups();

            if (activeGroups.length === 0) {
                return;
            }

            var topPointCoordinates;
            var bottomPointCoordinates;

            if (hpBufferSystem === HeatpumpBufferSystems.Unknown
                || hpBufferSystem === HeatpumpBufferSystems.Layered_Buffer_Storage_Or_Hygienic_Storage) {
                    /* Top short */
                    pipes.right.top.push(createPipe(581,277,13,Position.Horizontal));
                    /* Middle */
                    pipes.right.top.push(createPipe(586,280,140,Position.Vertical));

                    topPointCoordinates = { left: 587, top: 412, connectorLength: 19 };
                    bottomPointCoordinates = { left: 580, top: 430, connectorLength: 37 };
            }
            else if (hpBufferSystem === HeatpumpBufferSystems.Two_Buffer_System) {
                /* Top short */
                pipes.right.top.push(createPipe(581,277,13,Position.Horizontal));
                /* Middle */
                pipes.right.top.push(createPipe(586,280,150,Position.Vertical));

                topPointCoordinates = { left: 587, top: 422, connectorLength: 29 };
                bottomPointCoordinates = { left: 580, top: 462, connectorLength: 68 };
            }
            else if (hpBufferSystem === HeatpumpBufferSystems.Buffered_Storage) {
                /* Top short */
                pipes.right.top.push(createPipe(580,50,14,Position.Horizontal));
                /* Middle */
                pipes.right.top.push(createPipe(586,53,366,Position.Vertical));

                topPointCoordinates = { left: 587, top: 412, connectorLength: 19 };
                bottomPointCoordinates = { left: 580, top: 430, connectorLength: 37 };
            }

            var topLongLength;
            var bottomLongLength;

            for (var i = 0; i < activeGroups.length; i++) {
                var currentGroup = hkgs[activeGroups[i]];
                currentGroup.image.top = hkgs['g' + (i+1)].image.defaultTop;
                currentGroup.image.left = hkgs['g' + (i+1)].image.defaultLeft;

                var currentPipes = hkgs['g' + (i+1)].pipes;


                /* connector top */
                pipes.right.top.push(createPipe(currentPipes.top.left, currentPipes.top.top, topPointCoordinates.connectorLength, Position.Vertical));
                /* connector bottom */
                pipes.right.bottom.push(createPipe(currentPipes.bottom.left, currentPipes.bottom.top, bottomPointCoordinates.connectorLength, Position.Vertical));


                topLongLength = currentPipes.top.long;

                arrows.hkgs.left.push(createArrow(
                    { x: currentGroup.image.left + 19, y: currentGroup.image.top - 50 },
                    { x: currentGroup.image.left + 19, y: currentGroup.image.top - 2 }
                ));
                arrows.hkgs.right.push(createArrow(
                    { x: currentGroup.image.left + 80, y: currentGroup.image.top - 40 },
                    { x: currentGroup.image.left + 80, y: currentGroup.image.top - 88 }
                ));


            }

            bottomLongLength = topLongLength - 54;





            /* top long */
            pipes.right.top.push(createPipe(topPointCoordinates.left,topPointCoordinates.top,topLongLength,Position.Horizontal));
            /* bottom long */
            pipes.right.bottom.push(createPipe(bottomPointCoordinates.left,bottomPointCoordinates.top,bottomLongLength,Position.Horizontal));




            if (hkgs.g1.active) {
                showImage(hkgs.g1.image);
                vm.textObjects[hkgs.g1.id] = {title: $translate.instant('CUSTOM_OverviewHeatingCircuit_UI_MK1'), text: '1', top: hkgs.g1.image.top + 69, left: hkgs.g1.image.left + 76};
            }
            if (hkgs.g2.active) {
                showImage(hkgs.g2.image);
                vm.textObjects[hkgs.g2.id] = {title: $translate.instant('CUSTOM_OverviewHeatingCircuit_UI_MK2'), text: '2', top: hkgs.g2.image.top + 69, left: hkgs.g2.image.left + 76};
            }
            if (hkgs.g3.active) {
                showImage(hkgs.g3.image);
                vm.textObjects[hkgs.g3.id] = {title: $translate.instant('CUSTOM_OverviewHeatingCircuit_UI_MK3'), text: '3', top: hkgs.g3.image.top + 69, left: hkgs.g3.image.left + 76};
            }




            pipes.right.top.forEach(function(pipe) {
                canvas.add(pipe.body);
            });
            pipes.right.top.forEach(function(pipe) {
                canvas.add(pipe.gradient);
            });

            pipes.right.bottom.forEach(function(pipe) {
                canvas.add(pipe.body);
            });
            pipes.right.bottom.forEach(function(pipe) {
                canvas.add(pipe.gradient);
            });

            arrows.hkgs.left.forEach(function(arrow) {
                canvas.add(arrow);
            });
            arrows.hkgs.right.forEach(function(arrow) {
                canvas.add(arrow);
            });
        }

        function processDpValues(data) {
            if (!ranOnce) {
                ranOnce = true;
                if (hpBufferSystem !== HeatpumpBufferSystems.Without_Buffer) {
                    prepareHeizkreisGruppen();
                }
                if (hpBufferSystem === HeatpumpBufferSystems.Without_Buffer) {
                    hkgs.g1.active = hkgs.g2.active = hkgs.g3.active = false;
                }

                aktivateDebugFunctions();
            }

            var shorterLabelWidth = 60;
            var activeGroups = hkgs.fetchActiveGroups();
            if (activeGroups.length > 0) {
                for (var i = 0; i < activeGroups.length; i++) {
                    var currentGroup = hkgs[activeGroups[i]];
                    var forLabels = hkgs['g' + (i+1)].labels;

                    currentGroup.statusPumpe = data[currentGroup.labels.PumpeMKXDp.id].Value;

                    var statusPumpeDp = {
                        DatapointConfigId: currentGroup.labels.PumpeMKXDp.id,
                        _LabelWidth: 60,
                        _IsCentered: true
                    };

                    var ControlKermiMKXDp;
                    if (currentGroup.statusPumpe) {
                        if (areCoolingFeaturesActivated())
                        {
                            ControlKermiMKXDp = getHeatingCircuitStateByValue(data[xCenterConfig.datapointsInt['ControlKermiMK' + currentGroup.number]].Value);
                        } else {
                            ControlKermiMKXDp = data[currentGroup.labels.PumpeMKXDp.id].Value ? HeatingCircuitStates.Heating : HeatingCircuitStates.Off;
                        }
                    }
                    else {
                        ControlKermiMKXDp = HeatingCircuitStates.Off;
                    }
                    currentGroup.heatingCircuitState = ControlKermiMKXDp;

                    var HP_MKXSollTempPanelDp;
                    var HP_MKXIstTempDp;
                    var ist3WegeVentilDp;



                    if (currentGroup.labels.HP_MKXSollTempPanel || currentGroup.labels.HP_MKXIstTemp) {
                        HP_MKXSollTempPanelDp = data[xCenterConfig.datapointsFloat[currentGroup.labels.HP_MKXSollTempPanel.name]];
                        HP_MKXIstTempDp = data[xCenterConfig.datapointsFloat[currentGroup.labels.HP_MKXIstTemp.name]];
                    }
                    if (currentGroup.labels.MKXIst3WegeVentil) {
                        ist3WegeVentilDp = data[xCenterConfig.datapointsInt[currentGroup.labels.MKXIst3WegeVentil.name]];
                        ist3WegeVentilDp._LabelWidth = shorterLabelWidth;
                        ist3WegeVentilDp.transformToPossibleValue();
                    }

                    if (ControlKermiMKXDp === HeatingCircuitStates.Heating) {
                        arrows.setColors( [ arrows.hkgs.left[i] ], Colors.blue);
                        arrows.setColors( [ arrows.hkgs.right[i] ], Colors.red);

                        statusPumpeDp._LabelColor = Colors.green.value;
                        statusPumpeDp._ScreenValue = HeatingCircuitStates.Heating.DisplayName;

                        if (currentGroup.labels.HP_MKXSollTempPanel || currentGroup.labels.HP_MKXIstTemp) {
                            canvas.labels.setText(HP_MKXSollTempPanelDp, forLabels.HP_MKXSollTempPanel.left, forLabels.HP_MKXSollTempPanel.top);
                            canvas.labels.setText(HP_MKXIstTempDp, forLabels.HP_MKXIstTemp.left, forLabels.HP_MKXIstTemp.top);
                        }

                        if (currentGroup.labels.MKXIst3WegeVentil) {
                            canvas.labels.setText(ist3WegeVentilDp, forLabels.MKXIst3WegeVentil.left, forLabels.MKXIst3WegeVentil.top);
                        }
                    }
                    else if (ControlKermiMKXDp === HeatingCircuitStates.Cooling) {
                        arrows.setColors( [ arrows.hkgs.left[i] ], Colors.red);
                        arrows.setColors( [ arrows.hkgs.right[i] ], Colors.blue);

                        statusPumpeDp._LabelColor = Colors.lightBlue.value;
                        statusPumpeDp._ScreenValue = HeatingCircuitStates.Cooling.DisplayName;

                        if (currentGroup.labels.HP_MKXSollTempPanel || currentGroup.labels.HP_MKXIstTemp) {
                            HP_MKXSollTempPanelDp._LabelColor = Colors.lightBlue.value;
                            HP_MKXIstTempDp._LabelColor = Colors.lightBlue.value;

                            canvas.labels.setText(HP_MKXSollTempPanelDp, forLabels.HP_MKXSollTempPanel.left, forLabels.HP_MKXSollTempPanel.top);
                            canvas.labels.setText(HP_MKXIstTempDp, forLabels.HP_MKXIstTemp.left, forLabels.HP_MKXIstTemp.top);
                        }

                        if (currentGroup.labels.MKXIst3WegeVentil) {
                            ist3WegeVentilDp._LabelColor = Colors.lightBlue.value;

                            canvas.labels.setText(ist3WegeVentilDp, forLabels.MKXIst3WegeVentil.left, forLabels.MKXIst3WegeVentil.top);
                        }
                    }
                    else if (ControlKermiMKXDp === HeatingCircuitStates.Off) {
                        if (currentGroup.statusPumpe) {
                            arrows.setColors( [ arrows.hkgs.left[i] ], Colors.white);
                            arrows.setColors( [ arrows.hkgs.right[i] ], Colors.white);
                        } else {
                            arrows.setColors( [ arrows.hkgs.left[i] ], Colors.background);
                            arrows.setColors( [ arrows.hkgs.right[i] ], Colors.background);
                        }

                        statusPumpeDp._LabelColor = Colors.red.value;
                        statusPumpeDp._ScreenValue = HeatingCircuitStates.Off.DisplayName;

                        if (currentGroup.labels.HP_MKXSollTempPanel || currentGroup.labels.HP_MKXIstTemp) {
                            canvas.labels.removeText(HP_MKXSollTempPanelDp);
                            canvas.labels.removeText(HP_MKXIstTempDp);
                        }
                        if (currentGroup.labels.MKXIst3WegeVentil) {
                            ist3WegeVentilDp._LabelColor = Colors.red.value;

                            canvas.labels.setText(ist3WegeVentilDp, forLabels.MKXIst3WegeVentil.left, forLabels.MKXIst3WegeVentil.top);
                        }
                    }
                    else {
                        arrows.setColors( [ arrows.hkgs.left[i] ], Colors.white);
                        arrows.setColors( [ arrows.hkgs.right[i] ], Colors.white);

                        statusPumpeDp._LabelColor = 'yellow';
                        statusPumpeDp._ScreenValue = '?';

                        if (currentGroup.labels.HP_MKXSollTempPanel || currentGroup.labels.HP_MKXIstTemp) {
                            canvas.labels.removeText(HP_MKXSollTempPanelDp);
                            canvas.labels.removeText(HP_MKXIstTempDp);
                        }
                        if (currentGroup.labels.MKXIst3WegeVentil) {
                            canvas.labels.removeText(ist3WegeVentilDp);
                        }
                    }
                    canvas.labels.setText(statusPumpeDp, forLabels.PumpeMKXDp.left, forLabels.PumpeMKXDp.top);
                }
            }

            let promisses = [];
            promisses.push(versionMappingService.recallFunction('UmschaltventilHeizenTWE'));
            if (areCoolingFeaturesActivated()) {
                promisses.push(versionMappingService.recallFunction('EinschalthystereseKuehlen'));
            }
            promisses.push(versionMappingService.recallFunction('SolltemperaturKühlen'));
            promisses.push(versionMappingService.recallFunction('AktuellerPuffersollwert'));
            promisses.push(versionMappingService.recallFunction('EinschalthystereseTWE'));
            promisses.push(versionMappingService.recallFunction('EinschalthystereseHeating'));
            promisses.push(versionMappingService.recallFunction('AktuelleSollspreizungPufferladekreis'));
            promisses.push(versionMappingService.recallFunction('RegelsignalPufferladepumpe'));
            promisses.push(versionMappingService.recallFunction('StatusPufferladepumpe'));
            promisses.push(versionMappingService.recallFunction('ExternerWEZ1'));
            promisses.push(versionMappingService.recallFunction('ExternerWEZ2'));

            if (actualDevice.ConfigVersion && actualDevice.ConfigVersion >= 3) {
                promisses.push(versionMappingService.recallFunction('UsageExternalHeater1'));
                promisses.push(versionMappingService.recallFunction('UsageExternalHeater2'));
                promisses.push(versionMappingService.recallFunction('UsageExternalHeater3'));
                promisses.push(versionMappingService.recallFunction('ExternerWEZ3'));
            }

            homeserverVersionUsable('1.5.45')
            .then((isUsable) => {
                if (isUsable) {
                    if (actualDevice.ConfigVersion && actualDevice.ConfigVersion >= 5) {
                        promisses.push(versionMappingService.recallFunction('ExternerFlowrateWEZ1'));
                        promisses.push(versionMappingService.recallFunction('ExternerFlowrateWEZ2'));
                        promisses.push(versionMappingService.recallFunction('ExternerFlowrateWEZ3'));
                    }
                }
                data.ExternerFlowrateUsable = isUsable;

                $q.all(promisses)
                .then(function(getDps) {
                    let returnedDatapoints = {};
                    getDps.forEach(function(dp) {
                        const func = dp();
                        returnedDatapoints[func.FunctionName] = func.DatapointConfigId;
                    });

                    continueAfterPromise(data, returnedDatapoints);

                    canvas.renderAll();
                    overviewCircuitService.deactivateLoading();
                });
            });
        }

        function continueAfterPromise(data, dpIds) {
            /* Defaultvalues in ConfigVersion < 3 */
            let usageExternalHeater1 = HeatingTwe.Twe;
            let usageExternalHeater2 = HeatingTwe.Heating;
            let usageExternalHeater3 = HeatingTwe.Heating;

            let externerWEZ1 = data[dpIds.ExternerWEZ1].Value;
            let externerWEZ2 = data[dpIds.ExternerWEZ2].Value;
            let externerWEZ3;
            if (actualDevice.ConfigVersion && actualDevice.ConfigVersion >= 3) {
                externerWEZ3 = data[dpIds.ExternerWEZ3].Value;
            }

            let externerFlowrateWEZ1 = false;
            let externerFlowrateWEZ2 = false;
            let externerFlowrateWEZ3 = false;
            if (data.ExternerFlowrateUsable
                && actualDevice.ConfigVersion
                && actualDevice.ConfigVersion >= 5
                && hpBufferSystem !== HeatpumpBufferSystems.Without_Buffer) {

                externerFlowrateWEZ1 = data[dpIds.ExternerFlowrateWEZ1].Value;
                externerFlowrateWEZ2 = data[dpIds.ExternerFlowrateWEZ2].Value;
                externerFlowrateWEZ3 = data[dpIds.ExternerFlowrateWEZ3].Value;
            }

            let bivalenceStateDLE = false;
            let bivalenceStateTWE = false;
            let bivalenceStateHeating = false;

            if (actualDevice.ConfigVersion && actualDevice.ConfigVersion >= 3)
            {
                usageExternalHeater1 = getHeatingTwe(data[dpIds.UsageExternalHeater1].Value);
                usageExternalHeater2 = getHeatingTwe(data[dpIds.UsageExternalHeater2].Value);
                usageExternalHeater3 = getHeatingTwe(data[dpIds.UsageExternalHeater3].Value);
            }

            if (actualDevice.ConfigVersion && actualDevice.ConfigVersion >= 5)
            {
                bivalenceStateDLE |= externerWEZ1 && externerFlowrateWEZ1;
                bivalenceStateDLE |= externerWEZ2 && externerFlowrateWEZ2;
                bivalenceStateDLE |= externerWEZ3 && externerFlowrateWEZ3;
            }

            bivalenceStateTWE |= ((deepCompare([usageExternalHeater1, HeatingTwe.Twe]) || deepCompare([usageExternalHeater1, HeatingTwe.Both])) && externerWEZ1 && !externerFlowrateWEZ1);
            bivalenceStateTWE |= ((deepCompare([usageExternalHeater2, HeatingTwe.Twe]) || deepCompare([usageExternalHeater2, HeatingTwe.Both])) && externerWEZ2 && !externerFlowrateWEZ2);
            if (actualDevice.ConfigVersion && actualDevice.ConfigVersion >= 3) {
                bivalenceStateTWE |= ((deepCompare([usageExternalHeater3, HeatingTwe.Twe]) || deepCompare([usageExternalHeater3, HeatingTwe.Both])) && externerWEZ3 && !externerFlowrateWEZ3);
            }


            bivalenceStateHeating |= ((deepCompare([usageExternalHeater1, HeatingTwe.Heating]) || deepCompare([usageExternalHeater1, HeatingTwe.Both])) && externerWEZ1 && !externerFlowrateWEZ1);
            bivalenceStateHeating |= ((deepCompare([usageExternalHeater2, HeatingTwe.Heating]) || deepCompare([usageExternalHeater2, HeatingTwe.Both])) && externerWEZ2 && !externerFlowrateWEZ2);
            if (actualDevice.ConfigVersion && actualDevice.ConfigVersion >= 3) {
                bivalenceStateHeating |= ((deepCompare([usageExternalHeater3, HeatingTwe.Heating]) || deepCompare([usageExternalHeater3, HeatingTwe.Both])) && externerWEZ3 && !externerFlowrateWEZ3);
            }

            if (areCoolingFeaturesActivated() && hkgs.isAnyGroupCooling())
            {
                canvas.labels.setText(prepareCoolingLabels(data[dpIds.SolltemperaturKühlen]), 10, 30);
                canvas.labels.setText(prepareCoolingLabels(data[xCenterConfig.datapointsFloat.CoolingActualTemperatureBuffer]), 10, 54);
                canvas.labels.setText(prepareCoolingLabels(data[dpIds.EinschalthystereseKuehlen]), 10, 78);

                pipes.setColors(pipes.right.top, Colors.blue);
                pipes.setColors(pipes.right.bottom, Colors.red);
            }
            else if (hkgs.shouldDisplayGrayLines()) {
                pipes.setColors(pipes.right.top, Colors.white);
                pipes.setColors(pipes.right.bottom, Colors.white);
            }
            else {
                pipes.setColors(pipes.right.top, Colors.red);
                pipes.setColors(pipes.right.bottom, Colors.blue);

                if (areCoolingFeaturesActivated()) {
                    canvas.labels.removeText(data[dpIds.SolltemperaturKühlen]);
                    canvas.labels.removeText(data[xCenterConfig.datapointsFloat.CoolingActualTemperatureBuffer]);
                    canvas.labels.removeText(data[dpIds.EinschalthystereseKuehlen]);
                }
            }


            var Aussentemperatur_gemitteltDp = data[xCenterConfig.datapointsFloat.Aussentemperatur_gemittelt];
            vm.infoBar.OuterTemperature = roundToTwoFixedString(Aussentemperatur_gemitteltDp.Value) + ' ' + Aussentemperatur_gemitteltDp._Unit;

            vm.infoBar.HeatpumpState = getHeatpumpStateByValue(data[xCenterConfig.datapointsInt.HP_HeatpumpState].Value).DisplayName;
            vm.infoBar.HeatpumpStateIcon = getHeatpumpStateByValue(data[xCenterConfig.datapointsInt.HP_HeatpumpState].Value).EnumValueKey;

            const longerLabelWidth = 95;
            data[dpIds.RegelsignalPufferladepumpe]._LabelWidth = longerLabelWidth;
            data[dpIds.AktuelleSollspreizungPufferladekreis]._LabelWidth = longerLabelWidth;
            data[xCenterConfig.datapointsFloat.HPxyz_DurchflussIstLadekreis]._LabelWidth = longerLabelWidth;

            var UmschaltventilHeizenTWEDp;
            if (hpBufferSystem === HeatpumpBufferSystems.Unknown
                || hpBufferSystem === HeatpumpBufferSystems.Layered_Buffer_Storage_Or_Hygienic_Storage
                || hpBufferSystem === HeatpumpBufferSystems.Two_Buffer_System) {
                    UmschaltventilHeizenTWEDp = data[dpIds.UmschaltventilHeizenTWE];
                    UmschaltventilHeizenTWEDp._IsCentered = true;
                    if (UmschaltventilHeizenTWEDp.Value) {
                        UmschaltventilHeizenTWEDp._ScreenValue = $translate.instant('CUSTOM_OverviewHeatingCircuit_UI_Label_DHW');
                    } else {
                        UmschaltventilHeizenTWEDp._ScreenValue = $translate.instant('CUSTOM_OverviewHeatingCircuit_UI_Label_Buffer');
                    }
            }
            else if (hpBufferSystem === HeatpumpBufferSystems.Without_Buffer) {
                UmschaltventilHeizenTWEDp = data[dpIds.UmschaltventilHeizenTWE];
                UmschaltventilHeizenTWEDp._IsCentered = true;
                if (UmschaltventilHeizenTWEDp.Value) {
                    UmschaltventilHeizenTWEDp._ScreenValue = $translate.instant('CUSTOM_OverviewHeatingCircuit_UI_Label_DHW');
                } else {
                    UmschaltventilHeizenTWEDp._ScreenValue = $translate.instant('CUSTOM_OverviewHeatingCircuit_UI_Label_Dispatcher');
                }
            }

            var StatusPufferladepumpeDp = data[dpIds.StatusPufferladepumpe];

            let HP_TWESollDp = data[xCenterConfig.datapointsFloat.HP_TWESoll];
            var heatpumpStateName = getHeatpumpStateByValue(data[xCenterConfig.datapointsInt.HP_HeatpumpState].Value).EnumValueKey;

            if (hpBufferSystem === HeatpumpBufferSystems.Unknown
                || hpBufferSystem === HeatpumpBufferSystems.Layered_Buffer_Storage_Or_Hygienic_Storage) {

                    // DLE
                    if (bivalenceStateDLE) {
                        canvas.animations.dleLight.startBlinking(166, 290);
                    } else {
                        canvas.animations.dleLight.stopBlinking();
                    }

                    // TWE
                    if (bivalenceStateTWE) {
                        canvas.animations.topLight.startBlinking(407, 43);
                    } else {
                        canvas.animations.topLight.stopBlinking();
                    }

                    // Heizen
                    if (bivalenceStateHeating) {
                        canvas.animations.bottomLight.startBlinking(407, 305);
                    } else {
                        canvas.animations.bottomLight.stopBlinking();
                    }

                    var setPipesOnDefrostCooling = function() {
                        //pbPumpDefrostCooling.Visible = true;
                        // pb w, b, r, w; arrows: b ->, r <-
                        pipes.setColors(pipes.left.first, Colors.white);
                        pipes.setColors(pipes.left.second, Colors.blue);
                        pipes.setColors(pipes.left.third, Colors.red);
                        pipes.setColors(pipes.left.fourth, Colors.white);

                        arrows.setColors(arrows.plg.top, Colors.blue);
                        arrows.setColors(arrows.plg.bottom, Colors.red);
                    };

                    switch (heatpumpStateName) {
                         case HeatpumpStates.OnHeating.EnumValueKey:
                            //pbPumpHeating.Visible = true;
                            // pb w, r, b, w; arrows: r ->, b <-

                            pipes.setColors(pipes.left.first, Colors.white);
                            pipes.setColors(pipes.left.second, Colors.red);
                            pipes.setColors(pipes.left.third, Colors.blue);
                            pipes.setColors(pipes.left.fourth, Colors.white);

                            arrows.setColors(arrows.plg.top, Colors.red);
                            arrows.setColors(arrows.plg.bottom, Colors.blue);
                            break;
                        case HeatpumpStates.OnHotWater.EnumValueKey:
                            //pbPumpTWE.Visible = true;
                            // pb r, w, w, b; arrows: r ->, b <-
                            pipes.setColors(pipes.left.first, Colors.red);
                            pipes.setColors(pipes.left.second, Colors.white);
                            pipes.setColors(pipes.left.third, Colors.white);
                            pipes.setColors(pipes.left.fourth, Colors.blue);

                            arrows.setColors(arrows.plg.top, Colors.red);
                            arrows.setColors(arrows.plg.bottom, Colors.blue);
                            break;
                        case HeatpumpStates.OnDefrost.EnumValueKey:
                            if(UmschaltventilHeizenTWEDp.Value)
                            {
                                //pbPumpTWEDefrost
                                // pb b, w, w, r; arrows: b ->, r <-
                                pipes.setColors(pipes.left.first, Colors.blue);
                                pipes.setColors(pipes.left.second, Colors.white);
                                pipes.setColors(pipes.left.third, Colors.white);
                                pipes.setColors(pipes.left.fourth, Colors.red);

                                arrows.setColors(arrows.plg.top, Colors.blue);
                                arrows.setColors(arrows.plg.bottom, Colors.red);
                            }
                            else
                            {
                                //pbPumpDefrostCooling.Visible = true;
                                // pb w, b, r, w; arrows: b ->, r <-
                                setPipesOnDefrostCooling();
                            }
                            break;
                        case HeatpumpStates.Cooling.EnumValueKey:
                            //pbPumpDefrostCooling.Visible = true;
                            // pb w, b, r, w; arrows: b ->, r <-
                            setPipesOnDefrostCooling();
                            break;
                        default:
                            pipes.setColors(pipes.left.first, Colors.white);
                            pipes.setColors(pipes.left.second, Colors.white);
                            pipes.setColors(pipes.left.third, Colors.white);
                            pipes.setColors(pipes.left.fourth, Colors.white);

                            arrows.setColors(arrows.plg.top, Colors.white);
                            arrows.setColors(arrows.plg.bottom, Colors.white);
                            break;
                    }

                    canvas.labels.setText(UmschaltventilHeizenTWEDp, 64, 256);

                    canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_AuslasstempLadekreis], 11, 288);
                    canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_EinlasstempLadekreis], 11, 350);

                    if (StatusPufferladepumpeDp.Value && data[dpIds.RegelsignalPufferladepumpe].Value > 0) {
                        prepareOnOffLabel(StatusPufferladepumpeDp, true, longerLabelWidth);
                    } else {
                        prepareOnOffLabel(StatusPufferladepumpeDp, false, longerLabelWidth);
                    }
                    canvas.labels.setText(StatusPufferladepumpeDp, 173, 400);
                    canvas.labels.setText(data[dpIds.RegelsignalPufferladepumpe], 173, 424);
                    canvas.labels.setText(data[dpIds.AktuelleSollspreizungPufferladekreis], 173, 448);
                    canvas.labels.setText(data[xCenterConfig.datapointsFloat.HPxyz_DurchflussIstLadekreis], 173, 472);

                    /* Bei Einmalladung wird der Sollwert in der ControlLogic überschrieben. */
                    if (data[xCenterConfig.datapointsBool.HP_EinmalTWEPanel].Value === true) {
                        HP_TWESollDp.Value = data[xCenterConfig.datapointsFloat.HP_TWESollEinmal].Value;
                        HP_TWESollDp._ScreenValue = HP_TWESollDp.Value + ' ' + HP_TWESollDp._Unit;
                    }
                    if (data[xCenterConfig.datapointsBool.HP_General_TWE].Value === false) {
                        HP_TWESollDp.Value = 0;
                        HP_TWESollDp._ScreenValue = HP_TWESollDp.Value + ' ' + HP_TWESollDp._Unit;
                    }
                    canvas.labels.setText(HP_TWESollDp, 382, 80);
                    canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_TWETempIst], 382, 104);
                    canvas.labels.setText(data[dpIds.EinschalthystereseTWE], 382, 128);

                    canvas.labels.setText(data[dpIds.AktuellerPuffersollwert], 382, 342);
                    canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_IstTempHW], 382, 366);
                    canvas.labels.setText(data[dpIds.EinschalthystereseHeating], 382, 390);
            }
            else if (hpBufferSystem === HeatpumpBufferSystems.Two_Buffer_System) {
                // DLE
                if (bivalenceStateDLE) {
                    canvas.animations.dleLight.startBlinking(174, 145);
                } else {
                    canvas.animations.dleLight.stopBlinking();
                }

                // TWE
                if (bivalenceStateTWE) {
                    canvas.animations.topLight.startBlinking(448, 150);
                } else {
                    canvas.animations.topLight.stopBlinking();
                }

                // Heizen
                if (bivalenceStateHeating) {
                    canvas.animations.bottomLight.startBlinking(450, 397);
                } else {
                    canvas.animations.bottomLight.stopBlinking();
                }

                pipes.show(pipes.left.shared[0]);

                let setPipesOnCooling = function() {
                    pipes.setColors(pipes.left.first, Colors.white);
                    pipes.setColors(pipes.left.second, Colors.white);
                    pipes.setColors(pipes.left.third, Colors.blue);
                    pipes.setColors(pipes.left.fourth, Colors.red);
                    pipes.setColors(pipes.left.shared, Colors.red);

                    arrows.setColors(arrows.plg.top, Colors.blue);
                    arrows.setColors(arrows.plg.bottom, Colors.red);
                };

                switch (heatpumpStateName) {
                     case HeatpumpStates.OnHeating.EnumValueKey:
                        pipes.setColors(pipes.left.first, Colors.white);
                        pipes.setColors(pipes.left.second, Colors.white);
                        pipes.setColors(pipes.left.third, Colors.red);
                        pipes.setColors(pipes.left.fourth, Colors.blue);
                        pipes.setColors(pipes.left.shared, Colors.blue);

                        arrows.setColors(arrows.plg.top, Colors.red);
                        arrows.setColors(arrows.plg.bottom, Colors.blue);
                        break;
                    case HeatpumpStates.OnHotWater.EnumValueKey:
                        pipes.setColors(pipes.left.first, Colors.red);
                        pipes.setColors(pipes.left.second, Colors.blue);
                        pipes.setColors(pipes.left.third, Colors.white);
                        pipes.setColors(pipes.left.fourth, Colors.white);
                        pipes.setColors(pipes.left.shared, Colors.blue);

                        arrows.setColors(arrows.plg.top, Colors.red);
                        arrows.setColors(arrows.plg.bottom, Colors.blue);
                        break;
                    case HeatpumpStates.OnDefrost.EnumValueKey:
                        if(UmschaltventilHeizenTWEDp.Value)
                        {
                            pipes.setColors(pipes.left.first, Colors.blue);
                            pipes.setColors(pipes.left.second, Colors.red);
                            pipes.setColors(pipes.left.third, Colors.white);
                            pipes.setColors(pipes.left.fourth, Colors.white);
                            pipes.setColors(pipes.left.shared, Colors.red);

                            arrows.setColors(arrows.plg.top, Colors.blue);
                            arrows.setColors(arrows.plg.bottom, Colors.red);
                        }
                        else
                        {
                            setPipesOnCooling();
                        }
                        break;
                    case HeatpumpStates.Cooling.EnumValueKey:
                        setPipesOnCooling();
                        break;
                    default:
                        pipes.setColors(pipes.left.first, Colors.white);
                        pipes.setColors(pipes.left.second, Colors.white);
                        pipes.setColors(pipes.left.third, Colors.white);
                        pipes.setColors(pipes.left.fourth, Colors.white);
                        pipes.setColors(pipes.left.shared, Colors.white);

                        arrows.setColors(arrows.plg.top, Colors.white);
                        arrows.setColors(arrows.plg.bottom, Colors.white);
                        break;
                }

                canvas.labels.setText(UmschaltventilHeizenTWEDp, 145, 114);

                canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_AuslasstempLadekreis], 10, 120);
                canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_EinlasstempLadekreis], 10, 232);

                if (StatusPufferladepumpeDp.Value && data[dpIds.RegelsignalPufferladepumpe].Value > 0) {
                    prepareOnOffLabel(StatusPufferladepumpeDp, true, longerLabelWidth);
                } else {
                    prepareOnOffLabel(StatusPufferladepumpeDp, false, longerLabelWidth);
                }
                canvas.labels.setText(StatusPufferladepumpeDp, 140, 242);
                canvas.labels.setText(data[dpIds.RegelsignalPufferladepumpe], 140, 266);
                canvas.labels.setText(data[dpIds.AktuelleSollspreizungPufferladekreis], 140, 290);
                canvas.labels.setText(data[xCenterConfig.datapointsFloat.HPxyz_DurchflussIstLadekreis], 140, 314);

                /* Bei Einmalladung wird der Sollwert in der ControlLogic überschrieben. */
                if (data[xCenterConfig.datapointsBool.HP_EinmalTWEPanel].Value === true) {
                    HP_TWESollDp.Value = data[xCenterConfig.datapointsFloat.HP_TWESollEinmal].Value;
                    HP_TWESollDp._ScreenValue = HP_TWESollDp.Value + ' ' + HP_TWESollDp._Unit;
                }
                if (data[xCenterConfig.datapointsBool.HP_General_TWE].Value === false) {
                    HP_TWESollDp.Value = 0;
                    HP_TWESollDp._ScreenValue = HP_TWESollDp.Value + ' ' + HP_TWESollDp._Unit;
                }
                canvas.labels.setText(HP_TWESollDp, 346, 64);
                canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_TWETempIst], 346, 88);
                canvas.labels.setText(data[dpIds.EinschalthystereseTWE], 346, 112);

                canvas.labels.setText(data[dpIds.AktuellerPuffersollwert], 346, 330);
                canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_IstTempHW], 346, 354);
                canvas.labels.setText(data[dpIds.EinschalthystereseHeating], 346, 378);
            }
            else if (hpBufferSystem === HeatpumpBufferSystems.Buffered_Storage) {
                // DLE
                if (bivalenceStateDLE) {
                    canvas.animations.dleLight.startBlinking(175, 220);
                } else {
                    canvas.animations.dleLight.stopBlinking();
                }

                // Only Heizen
                if (bivalenceStateHeating) {
                    canvas.animations.bottomLight.startBlinking(410, 300);
                } else {
                    canvas.animations.bottomLight.stopBlinking();
                }

                switch (heatpumpStateName) {
                     case HeatpumpStates.OnHeating.EnumValueKey:
                     case HeatpumpStates.OnHotWater.EnumValueKey:
                        pipes.setColors(pipes.left.first, Colors.red);
                        pipes.setColors(pipes.left.second, Colors.blue);

                        arrows.setColors(arrows.plg.top, Colors.red);
                        arrows.setColors(arrows.plg.bottom, Colors.blue);
                        break;
                    case HeatpumpStates.OnDefrost.EnumValueKey:
                    case HeatpumpStates.Cooling.EnumValueKey:
                        pipes.setColors(pipes.left.first, Colors.blue);
                        pipes.setColors(pipes.left.second, Colors.red);

                        arrows.setColors(arrows.plg.top, Colors.blue);
                        arrows.setColors(arrows.plg.bottom, Colors.red);
                        break;
                    default:
                        pipes.setColors(pipes.left.first, Colors.white);
                        pipes.setColors(pipes.left.second, Colors.white);

                        arrows.setColors(arrows.plg.top, Colors.white);
                        arrows.setColors(arrows.plg.bottom, Colors.white);
                        break;
                }

                canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_AuslasstempLadekreis], 10, 194);
                canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_EinlasstempLadekreis], 10, 285);

                if (StatusPufferladepumpeDp.Value && data[dpIds.RegelsignalPufferladepumpe].Value > 0) {
                    prepareOnOffLabel(StatusPufferladepumpeDp, true, longerLabelWidth);
                } else {
                    prepareOnOffLabel(StatusPufferladepumpeDp, false, longerLabelWidth);
                }
                canvas.labels.setText(StatusPufferladepumpeDp, 140, 296);
                canvas.labels.setText(data[dpIds.RegelsignalPufferladepumpe], 140, 320);
                canvas.labels.setText(data[dpIds.AktuelleSollspreizungPufferladekreis], 140, 344);
                canvas.labels.setText(data[xCenterConfig.datapointsFloat.HPxyz_DurchflussIstLadekreis], 140, 368);

                canvas.labels.setText(data[dpIds.AktuellerPuffersollwert], 382, 212);
                canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_IstTempHW], 382, 236);
                canvas.labels.setText(data[dpIds.EinschalthystereseHeating], 382, 260);
            }
            else if (hpBufferSystem === HeatpumpBufferSystems.Without_Buffer) {
                // TWE or Heizen
                if (bivalenceStateTWE || bivalenceStateHeating) {
                    canvas.animations.topLight.startBlinking(172, 145);
                } else {
                    canvas.animations.topLight.stopBlinking();
                }

                pipes.show(pipes.left.shared[0]);

                let setPipesOnCooling = function() {
                    pipes.setColors(pipes.left.first, Colors.white);
                    pipes.setColors(pipes.left.second, Colors.white);
                    pipes.setColors(pipes.left.third, Colors.blue);
                    pipes.setColors(pipes.left.fourth, Colors.red);
                    pipes.setColors(pipes.left.shared, Colors.red);
                    pipes.setColors(pipes.left.fifth, Colors.blue);
                    pipes.setColors(pipes.left.sixth, Colors.red);
                    pipes.show(pipes.left.fourth[0]);

                    arrows.setColors(arrows.plg.top, Colors.blue);
                    arrows.setColors(arrows.plg.bottom, Colors.red);
                };

                var setCoolingLabels = function() {
                    canvas.labels.removeText(data[dpIds.AktuellerPuffersollwert]);
                    canvas.labels.removeText(data[xCenterConfig.datapointsFloat.HP_IstTempHW]);
                    canvas.labels.removeText(data[dpIds.EinschalthystereseHeating]);

                    canvas.labels.setText(prepareCoolingLabels(data[dpIds.SolltemperaturKühlen]), 646, 342);
                    canvas.labels.setText(prepareCoolingLabels(data[xCenterConfig.datapointsFloat.CoolingActualTemperatureBuffer]), 646, 366);
                    canvas.labels.setText(prepareCoolingLabels(data[dpIds.EinschalthystereseKuehlen]), 646, 390);
                };

                var setHeatingLabels = function() {
                    canvas.labels.removeText(data[dpIds.SolltemperaturKühlen]);
                    canvas.labels.removeText(data[xCenterConfig.datapointsFloat.CoolingActualTemperatureBuffer]);
                    canvas.labels.removeText(data[dpIds.EinschalthystereseKuehlen]);

                    canvas.labels.setText(data[dpIds.AktuellerPuffersollwert], 646, 342);
                    canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_IstTempHW], 646, 366);
                    canvas.labels.setText(data[dpIds.EinschalthystereseHeating], 646, 390);
                };

                switch (heatpumpStateName) {
                     case HeatpumpStates.OnHeating.EnumValueKey:
                        pipes.setColors(pipes.left.first, Colors.white);
                        pipes.setColors(pipes.left.second, Colors.white);
                        pipes.setColors(pipes.left.third, Colors.red);
                        pipes.setColors(pipes.left.fourth, Colors.blue);
                        pipes.setColors(pipes.left.shared, Colors.blue);
                        pipes.setColors(pipes.left.fifth, Colors.red);
                        pipes.setColors(pipes.left.sixth, Colors.blue);

                        arrows.setColors(arrows.plg.top, Colors.red);
                        arrows.setColors(arrows.plg.bottom, Colors.blue);

                        setHeatingLabels();
                        break;
                    case HeatpumpStates.OnHotWater.EnumValueKey:
                        pipes.setColors(pipes.left.first, Colors.red);
                        pipes.setColors(pipes.left.second, Colors.blue);
                        pipes.setColors(pipes.left.third, Colors.white);
                        pipes.setColors(pipes.left.fourth, Colors.white);
                        pipes.setColors(pipes.left.shared, Colors.blue);
                        pipes.setColors(pipes.left.fifth, Colors.red);
                        pipes.setColors(pipes.left.sixth, Colors.blue);

                        arrows.setColors(arrows.plg.top, Colors.red);
                        arrows.setColors(arrows.plg.bottom, Colors.blue);

                        setHeatingLabels();
                        break;
                    case HeatpumpStates.OnDefrost.EnumValueKey:
                        setPipesOnCooling();
                        setHeatingLabels();
                        break;
                    case HeatpumpStates.Cooling.EnumValueKey:
                        setPipesOnCooling();
                        setCoolingLabels();
                        break;
                    default:
                        pipes.setColors(pipes.left.first, Colors.white);
                        pipes.setColors(pipes.left.second, Colors.white);
                        pipes.setColors(pipes.left.third, Colors.white);
                        pipes.setColors(pipes.left.fourth, Colors.white);
                        pipes.setColors(pipes.left.shared, Colors.white);
                        pipes.setColors(pipes.left.fifth, Colors.white);
                        pipes.setColors(pipes.left.sixth, Colors.white);

                        arrows.setColors(arrows.plg.top, Colors.white);
                        arrows.setColors(arrows.plg.bottom, Colors.white);
                        setHeatingLabels();
                        break;
                }

                canvas.labels.setText(UmschaltventilHeizenTWEDp, 445, 114);

                canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_AuslasstempLadekreis], 10, 62);
                canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_EinlasstempLadekreis], 10, 232);

                if (StatusPufferladepumpeDp.Value && data[dpIds.RegelsignalPufferladepumpe].Value > 0) {
                    prepareOnOffLabel(StatusPufferladepumpeDp, true, longerLabelWidth);
                } else {
                    prepareOnOffLabel(StatusPufferladepumpeDp, false, longerLabelWidth);
                }
                canvas.labels.setText(StatusPufferladepumpeDp, 440, 242);
                canvas.labels.setText(data[dpIds.RegelsignalPufferladepumpe], 440, 266);
                canvas.labels.setText(data[dpIds.AktuelleSollspreizungPufferladekreis], 440, 290);
                canvas.labels.setText(data[xCenterConfig.datapointsFloat.HPxyz_DurchflussIstLadekreis], 440, 314);

                canvas.labels.setText(HP_TWESollDp, 646, 64);
                canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_TWETempIst], 646, 88);
                canvas.labels.setText(data[dpIds.EinschalthystereseTWE], 646, 112);
            }

            if (data[xCenterConfig.datapointsFloat.HP_TotalCOP] !== undefined) {
                var engineLoadKW = data[xCenterConfig.datapointsFloat.HP_AktuelleMotorleistungKW];
                var fanLoadKW = data[xCenterConfig.datapointsFloat.HP_FanAktuelleLeistung].Value;
                var cop = data[xCenterConfig.datapointsFloat.HP_TotalCOP].Value;

                switch (heatpumpStateName) {
                    case HeatpumpStates.Cooling.EnumValueKey:
                        vm.infoBar.LoadCaption = 'CUSTOM_OverviewCircuits_CoolingLoad';
                        vm.infoBar.Load = roundToTwoFixedString((engineLoadKW.Value + fanLoadKW) * cop, true) + ' ' + engineLoadKW._Unit;
                        vm.infoBar.EffectivityCaption = 'CUSTOM_OverviewCircuits_EER';
                        vm.infoBar.Effectivity = roundToTwoFixedString(cop, true);
                        break;
                    default:
                        vm.infoBar.LoadCaption = 'CUSTOM_OverviewCircuits_HeatingLoad';
                        vm.infoBar.Load = roundToTwoFixedString((engineLoadKW.Value + fanLoadKW) * cop) + ' ' + engineLoadKW._Unit;
                        vm.infoBar.EffectivityCaption = 'CUSTOM_OverviewCircuits_COP';
                        vm.infoBar.Effectivity = roundToTwoFixedString(cop);
                        break;
                }
            } else {
                vm.infoBar.LoadCaption = 'CUSTOM_OverviewCircuits_HeatingLoad';
                vm.infoBar.Load = '-';
                vm.infoBar.EffectivityCaption = 'CUSTOM_OverviewCircuits_COP';
                vm.infoBar.Effectivity = '-';
            }
        }

        function prepareCoolingLabels(dp) {
            dp._LabelColor = Colors.lightBlue.value;
            dp._LabelWidth = 80;
            return dp;
        }

        function aktivateDebugFunctions() {
            if (!vm.debug) {
                return;
            }
            frontEndSettingsService.getFrontendSettings()
            .then(function(settings) {
                vm.HomeServerVersion = settings.HomeServerVersion;
            });
            if (!vm.HeatpumpStates) {
                vm.HeatpumpStates = HeatpumpStates;
            }
            if (!vm.HeatpumpBufferSystems) {
                vm.HeatpumpBufferSystems = HeatpumpBufferSystems;
            }
            if (!vm.HeatingCircuitStates) {
                vm.HeatingCircuitStates = HeatingCircuitStates;
            }
            if (hpBufferSystem === HeatpumpBufferSystems.Without_Buffer) {
                vm.hkgs = undefined;
            } else {
                vm.hkgs = hkgs;
            }

        }

        vm.setHeatpumpState = function(value) {
            var api = new API();
            var writeValuesParams = {
                'DatapointValues': [{
                    '$type': 'BMS.Shared.DatapointCore.DatapointValue`1[[System.Int32, mscorlib]], BMS.Shared',
                    'DeviceId': actualDevice.DeviceId,
                    'DatapointConfigId': '41258683-9b38-4065-80d2-34c9a7e6ec2c',
                    'Value': value
                }]
            };
            return api.Datapoint.WriteValues(writeValuesParams).$promise;
        };

        vm.setHeatpumpBufferSystems = function(value) {
            var api = new API();
            var writeValuesParams = {
                'DatapointValues': [{
                    '$type': 'BMS.Shared.DatapointCore.DatapointValue`1[[System.Int32, mscorlib]], BMS.Shared',
                    'DeviceId': actualDevice.DeviceId,
                    'DatapointConfigId': '7a80fe50-7fb2-4de8-8e67-2002b887c10f',
                    'Value': value
                }]
            };
            return api.Datapoint.WriteValues(writeValuesParams).$promise
            .then(function() {
                // Such update won't happen with background refresh, so it is ok to reload the page
                $state.reload();
            });
        };

        vm.disableEnableHkg = function(value, datapointConfigId) {
            var api = new API();
            var writeValuesParams = {
                'DatapointValues': [{
                    '$type': 'BMS.Shared.DatapointCore.DatapointValue`1[[System.Boolean, mscorlib]], BMS.Shared',
                    'DeviceId': actualDevice.DeviceId,
                    'DatapointConfigId': datapointConfigId,
                    'Value': value
                }]
            };
            return api.Datapoint.WriteValues(writeValuesParams).$promise;
        };

        vm.setHeatingCircuitState = function(value, datapointConfigId) {
            var api = new API();
            var writeValuesParams = {
                'DatapointValues': [{
                    '$type': 'BMS.Shared.DatapointCore.DatapointValue`1[[System.Int32, mscorlib]], BMS.Shared',
                    'DeviceId': actualDevice.DeviceId,
                    'DatapointConfigId': datapointConfigId,
                    'Value': value
                }]
            };
            return api.Datapoint.WriteValues(writeValuesParams).$promise;
        };




        function roundToTwoFixedString(num, turnToAbs) {
            return (Math.round((turnToAbs ? Math.abs(+num) : (+num) + 0.00001) * 100) / 100 + '').replace(/\./g, ',');
        }

        function prepareOnOffLabel(dp, value, labelWidth) {
            if (dp === undefined) { return; }

            if ((typeof value === 'boolean') && value === true) {
                dp._ScreenValue = $translate.instant('On');
                dp._LabelColor = undefined;
            } else if ((typeof value === 'number') && value > 0) {
                dp._ScreenValue = $translate.instant('On');
                dp._LabelColor = undefined;
            } else {
                dp._ScreenValue = $translate.instant('Off');
                dp._LabelColor = Colors.red.value;
            }

            if (labelWidth !== undefined) {
                dp._LabelWidth = labelWidth;
            }
            dp._IsCentered = true;
        }

        $scope.$on('$destroy', function () {
            stopLoadTimers.configs = true;
            stopLoadTimers.dpValues = true;
            stopLoadTimers.deviceTypes = true;
            stopLoadTimers.heatpumpStateLastChanged = true;
        });

    }



})();
